import { z } from "zod";
import {
  DocumentMetaTs,
  LocaleTs,
} from "../../common";
import { MetaSchema } from "../components/shared.component";
import { OmitDocumentMeta } from "@/providers/strapi/client/types";
import { SingleTypes } from "..";
import { useContext } from "react";
import { ContentContext } from "../../content-provider";
import { BlogHeaderSchema, FeaturedArticleCardSchema, LastArticleCardSchema } from "../components/blog.component";




export type BlogHomePage = z.output<typeof BlogHomePageTs>;

export const BlogHomePageTs = DocumentMetaTs.extend({
  id: z.int(),
  locale: LocaleTs,
  localizations: z.array(DocumentMetaTs),
  metaData: MetaSchema,

  header: BlogHeaderSchema,
  featuredArticlesCard: FeaturedArticleCardSchema,
  lastArticlesCard: LastArticleCardSchema,
  moreArticleCta: z.string()
})

export const BLOG_HOME = 'blog-home-page';
export function useBlogHomePage<
  K extends keyof Omit<BlogHomePage, "id" | "locale" | "localizations" | OmitDocumentMeta>
>(
  entity: K,
  // contextKey: string
): BlogHomePage[K] {
  const content: Record<string, SingleTypes> | null = useContext(ContentContext);
  if (!content) throw new Error(`BlogHomePage content not found`)
  const singletype = content[BLOG_HOME] as BlogHomePage;
  if (!singletype || !singletype[entity]) throw new Error(`${entity} content not found`)
  return singletype[entity]
}

